import { httpClientPrivate } from "./axios";
import { accessToken } from "./token";

export const getAbilityApi = async()=>{
  return await httpClientPrivate.get(`/abilities`, accessToken());
}